import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import {
  ColumnModel,
  EditSettingsModel,
  ForeignKeyService,
  PageSettingsModel,
  SelectionSettingsModel,
} from '@syncfusion/ej2-angular-grids'
import { Cultura } from 'src/app/classes/Cultura'
import { Empresa, enumErpIntegrado } from 'src/app/classes/Empresa'
import { Safra } from 'src/app/classes/Safra'
import { SyncGridComponent } from 'src/app/components/shared-farm/sync-grid/sync-grid.component'
import { SafraService } from 'src/app/services/safra.service'
import { StorageService } from 'src/app/services/storage.service'
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component'
import { UtilsService } from 'src/app/utils/utils.service'
import * as $ from 'jquery'
import { FormControl, FormGroup, Validators } from '@angular/forms'

@Component({
  selector: 'app-lista-projetos-cultura',
  templateUrl: './lista-projetos-cultura.component.html',
  styleUrls: ['./lista-projetos-cultura.component.scss'],
  providers: [ForeignKeyService],
})
export class ListaProjetosCulturaComponent implements OnInit, OnChanges {
  @Input() culturas: Cultura[] = []
  @Output() finalizarSave: EventEmitter<any> = new EventEmitter()
  @ViewChild('Modal', { static: false })
  modal: UiModalComponent
  @ViewChild('gridProjeto', { static: false })
  gridProjeto: SyncGridComponent
  projetos: Safra[] = []
  projetoColumns: ColumnModel[] = []
  pageSettings?: PageSettingsModel = {
    pageSizes: [20, 50, 100],
    pageSize: 20,
    pageCount: 4,
  }
  editSettings?: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: false,
  }
  selectionSettings: SelectionSettingsModel  = { mode: 'Row', type: 'Single', checkboxMode: 'ResetOnRowClick' }
  enumErp = enumErpIntegrado
  empresa: Empresa = new Empresa()
  anoSafraId: number
  culturaId: number
  salvando: boolean = false

  constructor(
    private safraService: SafraService,
    private utils: UtilsService,
    private storageService: StorageService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['culturas']) this.configurarGrid()
  }

  ngOnInit() {
    this.empresa = this.storageService.getEmpresa()
  }

  abrirModal(anoSafraId: number): void {
    this.estadoPadraoBotoes()
    this.anoSafraId = anoSafraId
    this.culturaId = 0
    this.listarProjetos()
    this.modal.show()
  }

  estadoEmEdicaoBotoes(): void {
    $('#saveButton').show()
    $('#cancelButton').show()
    $('#addButton').hide()
    $('#editButton').hide()
    $('#removeButton').hide()
  }

  estadoPadraoBotoes(): void {
    $('#saveButton').hide()
    $('#cancelButton').hide()
    $('#addButton').show()
    $('#editButton').show()
    $('#removeButton').show()
  }

  fecharModal(): void {
    this.modal.hide()
  }

  configurarGrid(): void {
    this.projetoColumns = [
      { type: 'checkbox', width: 50, allowEditing: false, showInColumnChooser: false, showColumnMenu: false },
      {
        field: 'Descricao',
        headerText: 'Nome',
        allowSorting: true,
        validationRules: {
          required: true,
          minLength: [1, 'O campo Nome é obrigatório'],
          custom: [this.validateDescricao, 'O campo Nome não pode conter apenas espaços em branco']
        }
      },
      {
        field: 'CulturaId',
        headerText: 'Cultura',
        validationRules: { required: true },
        allowSorting: true,
        foreignKeyField: 'Id',
        foreignKeyValue: 'Descricao',
        dataSource: this.culturas,
      },
    ]

    if (this.empresa.ErpIntegrado == enumErpIntegrado.Sankhya)
      this.projetoColumns.push({
        field: 'CodProjetoSankhya',
        headerText: 'ID do Projeto',
        allowSorting: true,
      })

    if (this.empresa.ErpIntegrado == enumErpIntegrado.Totvs_RM) {
      this.projetoColumns.push({
        field: 'IdERP',
        headerText: 'ID do Projeto',
        allowSorting: true,
      })
      this.projetoColumns.push({
        field: 'CentroCustoERP',
        headerText: 'ID do Centro de Custo',
        allowSorting: true,
      })
    }
  }

  listarProjetos(): void {
    this.safraService.listarProjetosPorAnoSafra(this.anoSafraId).subscribe(
      (res) => {
        console.debug('projetos: ', res)
        this.projetos = res
      },
      (err) => {
        this.utils.getErro(err)
      },
    )
  }

  adicionar(): void {
    this.estadoEmEdicaoBotoes()
    this.gridProjeto.addRow()
  }

  salvar(projeto: Safra): void {
    this.salvando = true
    console.debug('salvar: ', projeto)
    if(!this.validarForm(projeto)){
      return;
    }
    if(projeto.Id){
      this.safraService.putSafra(projeto.Id, projeto).subscribe(
        res => {
          this.finalizarSaveRequestSuccess('Projeto atualizado com sucesso!')
        },
        err => {
          this.finalizarRequestError(err)
        }
      )
    }else{
      projeto.AnoSafraId = this.anoSafraId
      this.safraService.postSafra(projeto).subscribe(
        res => {
          this.finalizarSaveRequestSuccess('Projeto cadastrado com sucesso!')
        },
        err => {
          this.finalizarRequestError(err)
        }
      )
    }
  }

  cancelar(): void{
    this.gridProjeto.closeEdit()
    this.estadoPadraoBotoes();
  }

  editar(): void {
    if(!this.verificarSelecionado()) return;

    this.estadoEmEdicaoBotoes()
      this.gridProjeto.startEdit()
  }

  remover(): void {
    if(!this.verificarSelecionado()) return;
    this.salvando = true
    this.safraService.deleteSafra(this.gridProjeto.getSelectedRecords()[0].Id).subscribe(
      res => {
        this.salvando = false
        this.utils.handleSuccess('Projeto removido com sucesso.')
        this.listarProjetos()
      },
      err => {
        this.finalizarRequestError(err)
      }
    )
  }

  doubleClick(event): void {
    this.estadoEmEdicaoBotoes();
  }

  verificarSelecionado(): boolean {
    if(this.gridProjeto.getSelectedRecords().length == 0){
      this.utils.handleWarning('Selecione um projeto para realizar essa ação.')
      return false;
    }
    return true;
  }


  getFormulario(obj: Safra): FormGroup {
    return new FormGroup({
      grupoOperacao: new FormControl(obj.CulturaId, [
        Validators.required,
      ]),
      operacaoAgricola: new FormControl(obj.Descricao, [
        Validators.required,
        Validators.pattern(/^(?!\s*$).+/),
      ]),
    })
  }

    validarForm(projeto: Safra): boolean {
      if (!projeto.Descricao || projeto.Descricao.toString().trim().length === 0) {
        this.utils.handleWarning(
          `O campo 'Nome' é obrigatório e não pode conter apenas espaços em branco.`,
        )
        this.salvando = false
        return false
      }

      if (!projeto.CulturaId) {
        this.utils.handleWarning(
          `O campo 'Cultura' é obrigatório.`,
        )
        this.salvando = false
        return false
      }

      return true
    }

  finalizarSaveRequestSuccess(msg: string): void {
    this.utils.handleSuccess(msg)
    this.finalizarSave.emit()
    this.gridProjeto.closeEdit()
    this.salvando = false
    this.estadoPadraoBotoes()
    this.listarProjetos();
  }

  finalizarRequestError(error: any): void{
    this.salvando = false
    this.utils.getErro(error)
  }

  validateDescricao(args: any): boolean {
    if (!args.value) return false;
    const trimmedValue = args.value.toString().trim();
    return trimmedValue.length > 0;
  }
}
